import { isNull, today } from "App/utils/helpers";

export const STATE_JADWAL_DOKTER = {
  kode_poli_bpjs: "",
  tanggal: today(),
};

export const headCellsJadwalDokter = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "nik",
    disablePadding: false,
    label: "NIK",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "norekammedis",
    disablePadding: false,
    label: "NO. RM",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "noantrean",
    disablePadding: false,
    label: "NO. ANTREAN",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "tanggal",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "jeniskunjungan",
    disablePadding: false,
    label: "JENIS KUNJUNGAN",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "ispeserta",
    disablePadding: false,
    label: "STATUS PESERTA",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "estimasidilayani",
    disablePadding: false,
    label: "ESTIMASI DILAYANI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "kodepoli",
    disablePadding: false,
    label: "KODE POLI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "jampraktek",
    disablePadding: false,
    label: "JAM PRAKTEK",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "kodedokter",
    disablePadding: false,
    label: "KODE DOKTER",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "kodebooking",
    disablePadding: false,
    label: "KODE BOOKING",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "nohp",
    disablePadding: false,
    label: "NO. HP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nokapst",
    disablePadding: false,
    label: "NO. KAPST",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nomorreferensi",
    disablePadding: false,
    label: "NO. REF",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "sumberdata",
    disablePadding: false,
    label: "SUMBER DATA",
    align: "left",
    minWidth: "150px",
  },
];

export const renderJenisKunjungan = (id) => {
  if(!isNull(id)){
    switch (parseInt(id)) {
      case 1:
        return "Rujukan FKTP";
      case 2:
        return "Rujukan Internal";
      case 3:
        return "Kontrol";
      case 4:
        return "Rujukan Antar RS";
      default:
        return "-";
    }
  }else{
    return '-'
  }

};
